var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"excalidrawCard",staticClass:"excalidrawCard",attrs:{"id":"excalidraw"}},[_c('div',{ref:"excalidrawContainer",attrs:{"id":"excalidraw-container"}})])}
var staticRenderFns = []

export { render, staticRenderFns }